import React from 'react';
import './Gallery.css';
import GalleryGrid from "../GalleryGrid";

const Gallery = () => {

    return (
        <>
            <div className="gallery-container">
                <GalleryGrid/>
            </div>
            <div className="page-mailing-spacer gallery-mailing-spacer" style={{ height: 0 }} aria-hidden="true" />
        </>
    );
};

export default Gallery;
